/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppliedPatchGroupViewModel } from '../models/applied-patch-group-view-model';
import { BackupFileViewModel } from '../models/backup-file-view-model';
import { CancelOnDemandTaskRequest } from '../fn/developer/cancel-on-demand-task-request';
import { CancelOnDemandTaskRequest$Params } from '../fn/developer/cancel-on-demand-task-request';
import { GetDatabaseBackupURL } from '../fn/developer/get-database-backup-url';
import { GetDatabaseBackupURL$Params } from '../fn/developer/get-database-backup-url';
import { GetOnDemandTaskLogURL } from '../fn/developer/get-on-demand-task-log-url';
import { GetOnDemandTaskLogURL$Params } from '../fn/developer/get-on-demand-task-log-url';
import { GetS3BackupURL } from '../fn/developer/get-s-3-backup-url';
import { GetS3BackupURL$Params } from '../fn/developer/get-s-3-backup-url';
import { ListAppliedPatches } from '../fn/developer/list-applied-patches';
import { ListAppliedPatches$Params } from '../fn/developer/list-applied-patches';
import { ListDatabaseBackups } from '../fn/developer/list-database-backups';
import { ListDatabaseBackups$Params } from '../fn/developer/list-database-backups';
import { ListOnDemandTasks } from '../fn/developer/list-on-demand-tasks';
import { ListOnDemandTasks$Params } from '../fn/developer/list-on-demand-tasks';
import { ListS3Backups } from '../fn/developer/list-s-3-backups';
import { ListS3Backups$Params } from '../fn/developer/list-s-3-backups';
import { ListServerStatuses } from '../fn/developer/list-server-statuses';
import { ListServerStatuses$Params } from '../fn/developer/list-server-statuses';
import { ListServiceStatuses } from '../fn/developer/list-service-statuses';
import { ListServiceStatuses$Params } from '../fn/developer/list-service-statuses';
import { ListWebSiteRequests } from '../fn/developer/list-web-site-requests';
import { ListWebSiteRequests$Params } from '../fn/developer/list-web-site-requests';
import { ListWebSiteStatuses } from '../fn/developer/list-web-site-statuses';
import { ListWebSiteStatuses$Params } from '../fn/developer/list-web-site-statuses';
import { ListWebUrls } from '../fn/developer/list-web-urls';
import { ListWebUrls$Params } from '../fn/developer/list-web-urls';
import { OnDemandTaskViewModel } from '../models/on-demand-task-view-model';
import { RunOnDemandTask } from '../fn/developer/run-on-demand-task';
import { RunOnDemandTask$Params } from '../fn/developer/run-on-demand-task';
import { RunPatch } from '../fn/developer/run-patch';
import { RunPatch$Params } from '../fn/developer/run-patch';
import { SaveWebUrl } from '../fn/developer/save-web-url';
import { SaveWebUrl$Params } from '../fn/developer/save-web-url';
import { ServerStatusViewModelPrimeDatatableResults } from '../models/server-status-view-model-prime-datatable-results';
import { ServiceStatusViewModelPrimeDatatableResults } from '../models/service-status-view-model-prime-datatable-results';
import { SetWebSiteStatusMonitored } from '../fn/developer/set-web-site-status-monitored';
import { SetWebSiteStatusMonitored$Params } from '../fn/developer/set-web-site-status-monitored';
import { WebSiteRequestViewModelPrimeDatatableResults } from '../models/web-site-request-view-model-prime-datatable-results';
import { WebSiteStatusViewModelPrimeDatatableResults } from '../models/web-site-status-view-model-prime-datatable-results';
import { WebUrlModel } from '../models/web-url-model';
import { WebUrlViewModelPrimeDatatableResults } from '../models/web-url-view-model-prime-datatable-results';

@Injectable({ providedIn: 'root' })
export class DeveloperApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDeveloperListOnDemandTasksGet()` */
  static readonly ApiDeveloperListOnDemandTasksGetPath = '/api/Developer/ListOnDemandTasks';

  /**
   * List On Demand Tasks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListOnDemandTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListOnDemandTasks$Response(params?: ListOnDemandTasks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnDemandTaskViewModel>>> {
    return ListOnDemandTasks(this.http, this.rootUrl, params, context);
  }

  /**
   * List On Demand Tasks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListOnDemandTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListOnDemandTasks(params?: ListOnDemandTasks$Params, context?: HttpContext): Observable<Array<OnDemandTaskViewModel>> {
    return this.ListOnDemandTasks$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OnDemandTaskViewModel>>): Array<OnDemandTaskViewModel> => r.body)
    );
  }

  /** Path part for operation `apiDeveloperRunOnDemandTaskPost()` */
  static readonly ApiDeveloperRunOnDemandTaskPostPath = '/api/Developer/RunOnDemandTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RunOnDemandTask()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RunOnDemandTask$Response(params?: RunOnDemandTask$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return RunOnDemandTask(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RunOnDemandTask$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RunOnDemandTask(params?: RunOnDemandTask$Params, context?: HttpContext): Observable<string> {
    return this.RunOnDemandTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiDeveloperCancelOnDemandTaskRequestPost()` */
  static readonly ApiDeveloperCancelOnDemandTaskRequestPostPath = '/api/Developer/CancelOnDemandTaskRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `CancelOnDemandTaskRequest()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  CancelOnDemandTaskRequest$Response(params?: CancelOnDemandTaskRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return CancelOnDemandTaskRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `CancelOnDemandTaskRequest$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  CancelOnDemandTaskRequest(params?: CancelOnDemandTaskRequest$Params, context?: HttpContext): Observable<string> {
    return this.CancelOnDemandTaskRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListAppliedPatchesGet()` */
  static readonly ApiDeveloperListAppliedPatchesGetPath = '/api/Developer/ListAppliedPatches';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListAppliedPatches()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListAppliedPatches$Response(params?: ListAppliedPatches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppliedPatchGroupViewModel>>> {
    return ListAppliedPatches(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListAppliedPatches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListAppliedPatches(params?: ListAppliedPatches$Params, context?: HttpContext): Observable<Array<AppliedPatchGroupViewModel>> {
    return this.ListAppliedPatches$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AppliedPatchGroupViewModel>>): Array<AppliedPatchGroupViewModel> => r.body)
    );
  }

  /** Path part for operation `apiDeveloperRunPatchPost()` */
  static readonly ApiDeveloperRunPatchPostPath = '/api/Developer/RunPatch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RunPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RunPatch$Response(params?: RunPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return RunPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RunPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RunPatch(params?: RunPatch$Params, context?: HttpContext): Observable<string> {
    return this.RunPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListServerStatusesPost()` */
  static readonly ApiDeveloperListServerStatusesPostPath = '/api/Developer/ListServerStatuses';

  /**
   * List Server Statuses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListServerStatuses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServerStatuses$Response(params?: ListServerStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerStatusViewModelPrimeDatatableResults>> {
    return ListServerStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List Server Statuses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListServerStatuses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServerStatuses(params?: ListServerStatuses$Params, context?: HttpContext): Observable<ServerStatusViewModelPrimeDatatableResults> {
    return this.ListServerStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServerStatusViewModelPrimeDatatableResults>): ServerStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListServiceStatusesPost()` */
  static readonly ApiDeveloperListServiceStatusesPostPath = '/api/Developer/ListServiceStatuses';

  /**
   * List Service Statuses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListServiceStatuses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServiceStatuses$Response(params?: ListServiceStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceStatusViewModelPrimeDatatableResults>> {
    return ListServiceStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List Service Statuses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListServiceStatuses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListServiceStatuses(params?: ListServiceStatuses$Params, context?: HttpContext): Observable<ServiceStatusViewModelPrimeDatatableResults> {
    return this.ListServiceStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServiceStatusViewModelPrimeDatatableResults>): ServiceStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListWebSiteStatusesPost()` */
  static readonly ApiDeveloperListWebSiteStatusesPostPath = '/api/Developer/ListWebSiteStatuses';

  /**
   * List Web Site Statuses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListWebSiteStatuses()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteStatuses$Response(params?: ListWebSiteStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<WebSiteStatusViewModelPrimeDatatableResults>> {
    return ListWebSiteStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List Web Site Statuses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListWebSiteStatuses$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteStatuses(params?: ListWebSiteStatuses$Params, context?: HttpContext): Observable<WebSiteStatusViewModelPrimeDatatableResults> {
    return this.ListWebSiteStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebSiteStatusViewModelPrimeDatatableResults>): WebSiteStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperSetWebSiteStatusMonitoredPost()` */
  static readonly ApiDeveloperSetWebSiteStatusMonitoredPostPath = '/api/Developer/SetWebSiteStatusMonitored';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetWebSiteStatusMonitored()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetWebSiteStatusMonitored$Response(params?: SetWebSiteStatusMonitored$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetWebSiteStatusMonitored(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetWebSiteStatusMonitored$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetWebSiteStatusMonitored(params?: SetWebSiteStatusMonitored$Params, context?: HttpContext): Observable<boolean> {
    return this.SetWebSiteStatusMonitored$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListWebSiteRequestsPost()` */
  static readonly ApiDeveloperListWebSiteRequestsPostPath = '/api/Developer/ListWebSiteRequests';

  /**
   * List Web Site Requests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListWebSiteRequests()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteRequests$Response(params?: ListWebSiteRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<WebSiteRequestViewModelPrimeDatatableResults>> {
    return ListWebSiteRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * List Web Site Requests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListWebSiteRequests$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebSiteRequests(params?: ListWebSiteRequests$Params, context?: HttpContext): Observable<WebSiteRequestViewModelPrimeDatatableResults> {
    return this.ListWebSiteRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebSiteRequestViewModelPrimeDatatableResults>): WebSiteRequestViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListWebUrlsPost()` */
  static readonly ApiDeveloperListWebUrlsPostPath = '/api/Developer/ListWebUrls';

  /**
   * List Web URLs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListWebUrls()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebUrls$Response(params?: ListWebUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<WebUrlViewModelPrimeDatatableResults>> {
    return ListWebUrls(this.http, this.rootUrl, params, context);
  }

  /**
   * List Web URLs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListWebUrls$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListWebUrls(params?: ListWebUrls$Params, context?: HttpContext): Observable<WebUrlViewModelPrimeDatatableResults> {
    return this.ListWebUrls$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebUrlViewModelPrimeDatatableResults>): WebUrlViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiDeveloperSaveWebUrlPost()` */
  static readonly ApiDeveloperSaveWebUrlPostPath = '/api/Developer/SaveWebUrl';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveWebUrl()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveWebUrl$Response(params?: SaveWebUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<WebUrlModel>> {
    return SaveWebUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveWebUrl$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveWebUrl(params?: SaveWebUrl$Params, context?: HttpContext): Observable<WebUrlModel> {
    return this.SaveWebUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebUrlModel>): WebUrlModel => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListDatabaseBackupsPost()` */
  static readonly ApiDeveloperListDatabaseBackupsPostPath = '/api/Developer/ListDatabaseBackups';

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListDatabaseBackups()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListDatabaseBackups$Response(params?: ListDatabaseBackups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BackupFileViewModel>>> {
    return ListDatabaseBackups(this.http, this.rootUrl, params, context);
  }

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListDatabaseBackups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListDatabaseBackups(params?: ListDatabaseBackups$Params, context?: HttpContext): Observable<Array<BackupFileViewModel>> {
    return this.ListDatabaseBackups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BackupFileViewModel>>): Array<BackupFileViewModel> => r.body)
    );
  }

  /** Path part for operation `apiDeveloperGetDatabaseBackupUrlPost()` */
  static readonly ApiDeveloperGetDatabaseBackupUrlPostPath = '/api/Developer/GetDatabaseBackupURL';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetDatabaseBackupURL()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetDatabaseBackupURL$Response(params?: GetDatabaseBackupURL$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetDatabaseBackupURL(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetDatabaseBackupURL$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetDatabaseBackupURL(params?: GetDatabaseBackupURL$Params, context?: HttpContext): Observable<string> {
    return this.GetDatabaseBackupURL$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiDeveloperListS3BackupsPost()` */
  static readonly ApiDeveloperListS3BackupsPostPath = '/api/Developer/ListS3Backups';

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListS3Backups()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListS3Backups$Response(params?: ListS3Backups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BackupFileViewModel>>> {
    return ListS3Backups(this.http, this.rootUrl, params, context);
  }

  /**
   * List Database Backups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListS3Backups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ListS3Backups(params?: ListS3Backups$Params, context?: HttpContext): Observable<Array<BackupFileViewModel>> {
    return this.ListS3Backups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BackupFileViewModel>>): Array<BackupFileViewModel> => r.body)
    );
  }

  /** Path part for operation `apiDeveloperGetS3BackupUrlPost()` */
  static readonly ApiDeveloperGetS3BackupUrlPostPath = '/api/Developer/GetS3BackupURL';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetS3BackupURL()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetS3BackupURL$Response(params?: GetS3BackupURL$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetS3BackupURL(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetS3BackupURL$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetS3BackupURL(params?: GetS3BackupURL$Params, context?: HttpContext): Observable<string> {
    return this.GetS3BackupURL$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiDeveloperGetOnDemandTaskLogUrlPost()` */
  static readonly ApiDeveloperGetOnDemandTaskLogUrlPostPath = '/api/Developer/GetOnDemandTaskLogURL';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetOnDemandTaskLogURL()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetOnDemandTaskLogURL$Response(params?: GetOnDemandTaskLogURL$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetOnDemandTaskLogURL(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetOnDemandTaskLogURL$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetOnDemandTaskLogURL(params?: GetOnDemandTaskLogURL$Params, context?: HttpContext): Observable<string> {
    return this.GetOnDemandTaskLogURL$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
